import * as React from 'react';
import * as style from './style.css';
import { Tooltip } from '@cian/ui-kit';
import { EStatus } from '../../../../types/offers';
import { useCompare } from '../../../../hooks/useCompare';
import { OffersContext } from '../../../../shared/context';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const Compare = _ref => {
  let {
    status,
    offerId
  } = _ref;
  const {
    addOfferToComparison,
    removeOfferFromComparison
  } = React.useContext(OffersContext);
  const {
    icon,
    tooltipText
  } = useCompare({
    status
  });
  const onClick = React.useCallback(() => {
    if (status === EStatus.Available) {
      addOfferToComparison(offerId);
    } else {
      removeOfferFromComparison(offerId);
    }
  }, [offerId, status]);
  if (!icon) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipText,
    children: /*#__PURE__*/_jsx("button", {
      role: "button",
      "data-testid": "CompareButton",
      onClick: onClick,
      className: clsx(style['button'], status === EStatus.Added && style['active']),
      children: icon
    })
  });
};